"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UncheckedIcon = exports.LabelText = exports.CheckedIcon = exports.BaseCheckbox = void 0;

var _fieldAlert = require("./forms/field-alert");

var _fieldsStyledComponents = require("./forms/fields-styled-components");

var _media = require("react-components/media");

var _styles = require("react-components/styles");

var _styledTools = require("styled-tools");

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _excluded = ["className", "disabled", "hasError", "helpText", "isOpen", "label"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var checkedIcon = "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\"><g stroke-width=\"2\"><rect class=\"checkbox-icon-stroke-color\" width=\"22\" height=\"22\" x=\"1\" y=\"1\" rx=\"5\"/><rect width=\"20\" height=\"20\" x=\"2\" y=\"2\" fill=\"currentColor\" rx=\"3\"/><path stroke=\"#fff\" stroke-miterlimit=\"10\" d=\"M17.688 8.745L12.3 15.358c-.421.512-.992.833-1.607.903h-.845c-.615-.07-1.187-.391-1.607-.903L6.313 13.04\"/></g></svg>";
var uncheckedIcon = "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\"><rect width=\"18\" height=\"18\" x=\"2.999\" y=\"2.846\" stroke=\"currentColor\" stroke-width=\"2\" rx=\"3\"/></svg>";
/**
 * `CheckboxProps` type.
 */

/**
 * Checkbox size.
 */
var checkboxSize = '24px';
/**
 * `StyledIcon` styled component.
 */

var StyledIcon = (0, _styledComponents["default"])(_media.Icon).attrs({
  'aria-hidden': true
}).withConfig({
  displayName: "checkbox__StyledIcon",
  componentId: "sc-12maums-0"
})(["grid-area:checkbox;max-width:", ";transition:", ";transition-property:color,opacity;width:", ";"], checkboxSize, (0, _styledTools.theme)('animations.defaultTransition'), checkboxSize);
/**
 * Export `CheckedIcon` styled component.
 */

var CheckedIcon = (0, _styledComponents["default"])(StyledIcon).withConfig({
  displayName: "checkbox__CheckedIcon",
  componentId: "sc-12maums-1"
})(["color:", ";opacity:0;"], (0, _styles.color)('primary'));
/**
 * Export `UncheckedIcon` styled component.
 */

exports.CheckedIcon = CheckedIcon;
var UncheckedIcon = (0, _styledComponents["default"])(StyledIcon).withConfig({
  displayName: "checkbox__UncheckedIcon",
  componentId: "sc-12maums-2"
})(["color:", ";opacity:1;"], (0, _styles.color)('gray500'));
/**
 * `Label` styled component.
 */

exports.UncheckedIcon = UncheckedIcon;

var Label = _styledComponents["default"].label.withConfig({
  displayName: "checkbox__Label",
  componentId: "sc-12maums-3"
})(["", " align-items:center;color:", ";cursor:pointer;display:grid;grid-column-gap:4px;grid-template-areas:'checkbox label';grid-template-columns:", " 1fr;transition:color ", ";", " ", ""], _fieldsStyledComponents.textDesktopStyle, (0, _styles.color)('secondary'), checkboxSize, (0, _styledTools.theme)('animations.defaultTransition'), (0, _styledTools.ifProp)('hasError', (0, _styledComponents.css)(["color:", ";"], (0, _styles.color)('danger'))), (0, _styledTools.ifProp)('disabled', (0, _styledComponents.css)(["color:", ";"], (0, _styles.color)('gray400'))));
/**
 * Export `LabelText` styled component.
 */


var LabelText = _styledComponents["default"].span.withConfig({
  displayName: "checkbox__LabelText",
  componentId: "sc-12maums-4"
})(["grid-area:label;"]);
/**
 * `Input` styled component.
 */


exports.LabelText = LabelText;

var Input = _styledComponents["default"].input.withConfig({
  displayName: "checkbox__Input",
  componentId: "sc-12maums-5"
})(["cursor:pointer;grid-area:checkbox;height:", ";opacity:0;width:", ";z-index:1;&:checked{& ~ ", "{opacity:0;}& ~ ", "{opacity:1;}}&:focus-visible{& ~ ", "{color:", ";}&:checked ~ ", "{.checkbox-icon-stroke-color{stroke:", ";}}}&:hover{& ~ ", "{color:", ";}&:checked ~ ", "{color:", ";}}&:disabled{& ~ ", ",&:checked ~ ", "{color:", ";}}"], checkboxSize, checkboxSize, UncheckedIcon, CheckedIcon, UncheckedIcon, (0, _styles.color)('blue200'), CheckedIcon, (0, _styles.color)('blue200'), UncheckedIcon, (0, _styles.color)('gray600'), CheckedIcon, (0, _styles.color)('blue600'), UncheckedIcon, CheckedIcon, (0, _styles.color)('gray400'));
/**
 * `Checkbox` component.
 */


function Checkbox(props, ref) {
  var className = props.className,
      disabled = props.disabled,
      hasError = props.hasError,
      helpText = props.helpText,
      isOpen = props.isOpen,
      label = props.label,
      rest = _objectWithoutProperties(props, _excluded);

  return /*#__PURE__*/_react["default"].createElement(_fieldsStyledComponents.FormGroup, {
    className: className,
    disabled: disabled
  }, /*#__PURE__*/_react["default"].createElement(Label, {
    disabled: disabled,
    hasError: hasError
  }, label && /*#__PURE__*/_react["default"].createElement(LabelText, null, label), /*#__PURE__*/_react["default"].createElement(Input, _extends({
    disabled: disabled,
    ref: ref,
    type: 'checkbox'
  }, rest)), /*#__PURE__*/_react["default"].createElement(UncheckedIcon, {
    icon: uncheckedIcon
  }), /*#__PURE__*/_react["default"].createElement(CheckedIcon, {
    icon: checkedIcon
  })), helpText && /*#__PURE__*/_react["default"].createElement(_fieldAlert.FieldAlert, {
    isOpen: isOpen !== null && isOpen !== void 0 ? isOpen : !hasError
  }, helpText));
}
/**
 * Forwarded `Checkbox`.
 */


var ForwardedCheckbox = /*#__PURE__*/(0, _react.forwardRef)(Checkbox);
/**
 * Export `BaseCheckbox` component.
 */

exports.BaseCheckbox = ForwardedCheckbox;